import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BadgeModule } from '../badge';
import { AvatarComponent } from './components';

@NgModule({
    imports: [
        CommonModule,

        BadgeModule,
    ],
    declarations: [
        AvatarComponent,
    ],
    exports: [
        AvatarComponent,
    ],
})

export class AvatarModule {}
